import { useTranslation } from 'react-i18next';

type TFunction = ReturnType<typeof useTranslation>['t'];

/**
 * Utility function to translate attribute data types
 * Maps API attribute types to their translated labels
 */
export function translateAttributeType(dataType: string, t: TFunction): string {
  const typeMapping: Record<string, string> = {
    text: t('attributes.enhanced.modal.dataTypes.text.label', 'Text'),
    number: t('attributes.enhanced.modal.dataTypes.number.label', 'Number'),
    boolean: t('attributes.enhanced.modal.dataTypes.boolean.label', 'Boolean'),
    select: t('attributes.enhanced.modal.dataTypes.select.label', 'Select'),
    multiselect: t('attributes.enhanced.modal.dataTypes.multiselect.label', 'Multi Select'),
    date: t('attributes.enhanced.modal.dataTypes.date.label', 'Date'),
    rich_text: t('attributes.enhanced.modal.dataTypes.rich_text.label', 'Rich Text'),
    price: t('attributes.enhanced.modal.dataTypes.price.label', 'Price'),
    media: t('attributes.enhanced.modal.dataTypes.media.label', 'Media'),
    measurement: t('attributes.enhanced.modal.dataTypes.measurement.label', 'Measurement'),
    url: t('attributes.enhanced.modal.dataTypes.url.label', 'URL'),
    email: t('attributes.enhanced.modal.dataTypes.email.label', 'Email'),
    phone: t('attributes.enhanced.modal.dataTypes.phone.label', 'Phone'),
    file: t('attributes.enhanced.modal.dataTypes.file.label', 'File'),
    textarea: t('attributes.enhanced.modal.dataTypes.textarea.label', 'Textarea'),
    image: t('attributes.enhanced.modal.dataTypes.image.label', 'Image'),
  };

  return typeMapping[dataType] || dataType;
}

/**
 * React hook for attribute type translation
 */
export function useAttributeTypeTranslation(t: TFunction) {
  return (dataType: string) => translateAttributeType(dataType, t);
}
